import React from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { getMessage, updateMessage } from 'app-support/messages/state/actions'
import MessageForm from './Form'
import { ISupportMessage } from '@cbgms/api/modules/messages'
import useQuery from '@cbgms/base/http/use-query'
import { Loader } from '@carsys/ui'
import { useNotifier } from '@cbgms/base/notifier'
import { fetchShopId } from 'app-support/stats/utils'

const EditMessage: React.FC<{}> = () => {
  const { t } = useTranslation()
  const { messageUUID } = useParams<{ messageUUID: string }>()
  const dispatch = useDispatch()
  const notifier = useNotifier()

  const { isLoading, data } = useQuery(['MESSAGES_FORM', messageUUID], async () => {
    const result = await dispatch(getMessage(messageUUID))
    return result
  })

  const onSubmit = async (values: ISupportMessage) => {
    const Formvalues = { ...values }
    const shopId = fetchShopId(Formvalues.ShopIDs)
    Formvalues.ShopIDs = shopId ? [shopId] : []
    await dispatch(updateMessage(Formvalues.UUID, Formvalues))
    return values
  }
  const onSubmitSuccess = () => {
    notifier.success(t('global.successfully_saved'))
  }

  if (isLoading || !data) {
    return <Loader loading />
  }

  return <MessageForm initialValues={data?.Data} onSubmit={onSubmit} onSubmitSuccess={onSubmitSuccess} />
}

export default EditMessage
